"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptIfDirty = void 0;
const react_intl_1 = require("react-intl");
const react_router_dom_1 = require("react-router-dom");
const react_hook_form_1 = require("react-hook-form");
const PromptIfDirty = props => {
    const { visible = true } = props;
    const { formState: { isDirty }, } = (0, react_hook_form_1.useFormContext)();
    const { formatMessage } = (0, react_intl_1.useIntl)();
    (0, react_router_dom_1.unstable_usePrompt)({
        message: formatMessage({ id: "form.hints.prompt" }),
        when: visible && isDirty,
    });
    return null;
};
exports.PromptIfDirty = PromptIfDirty;
//# sourceMappingURL=index.js.map